import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs';
import { RbacService, SystemViewModel } from 'src/app/api-info/system-management-api';
import { SYSTEM_CODE } from '../constants/global-constants.constant';
import { SystemInfo } from '../models/system-info';
import { isNullOrEmpty } from '../utils/common-functions';

/**
 * 系統資訊服務
 *
 * @export
 * @class SystemEnvService
 */
@Injectable({
  providedIn: 'root',
})
export class SystemEnvService {
  private sysInfo: SystemInfo = {};
  private sysList: SystemViewModel[] = [];

  constructor(private logger: NGXLogger, private rbacService: RbacService,) {}

  /**
   * 系統列表
   */
  get systemList(): SystemViewModel[] {
    return this.sysList;
  }

  /**
   * 此系統資訊
   */
  get systemInfo(): SystemInfo {
    return this.sysInfo ?? {};
  }

  /**
   * 初始化系統資訊
   *
   * @return {*}  {Observable<void>}
   * @memberof SystemEnvService
   */
  initSystemInfo(): Observable<void> {
    const observerable$ = new Observable<void>((observer) => {
      this.rbacService.rbacSystemGet().subscribe({
        next: (results) => {
          this.logger.info(
            'SystemEnvService - initSystemInfo - rbacSystemGet - success',
            results
          );
          this.sysList = results;
          const currentSystemInfo = results.find(
            (x) => x.systemCode === SYSTEM_CODE
          );
          if (isNullOrEmpty(currentSystemInfo)) {
            observer.error(new Error('Fail to get system info.'));
          }
          this.sysInfo = {
            systemId: currentSystemInfo?.systemId,
            systemCode: currentSystemInfo?.systemCode,
            systemName: currentSystemInfo?.systemName,
            systemHostUrl: currentSystemInfo?.systemHostUrl,
          };

          observer.next();
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
    return observerable$;
  }
}
